import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasParentProductId, withParentProductId } from "@insite/client-framework/Components/ParentProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

// eslint-disable-next-line no-use-before-define
type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasParentProductId;

const mapStateToProps = (state: ApplicationState, ownProps: HasParentProductId) => ({
    configuration: getProductState(state, ownProps.parentProductId).value?.detail?.configuration,
});

export interface ProductDetailsKitSectionOptionsStyles {
    wrapper?: InjectableCss;
    configSectionWrapper?: InjectableCss;
    configSectionLabel?: TypographyPresentationProps;
    sectionOptionText?: TypographyPresentationProps;
    kitWrap?: GridItemProps;
    kitContainer?: GridContainerProps;
    contentWrap?: InjectableCss;
    title?: InjectableCss;
    desc?: InjectableCss;
    productDesc?: InjectableCss;
    gridWrapper?: InjectableCss;
}

export const productDetailsKitSectionOptionsStyles: ProductDetailsKitSectionOptionsStyles = {
    wrapper: {
        css: css`
            margin-bottom: 10px;
            line-height: 25px;
        `,
    },
    configSectionLabel: {
        weight: "normal",
        css: css`
            display: block;
        `,
    },
    sectionOptionText: {
        css: css`
            display: block;
            color: #353432;
            font-weight: 600;
        `,
    },
    kitContainer: {
        gap: 10,
    },
    kitWrap: {
        width: [6, 6, 3, 3, 3],
        // css: css`
        //     flex-basis: 20%;
        //     max-width: 20%;
        // `,
    },
    gridWrapper: {
        css: css`
            display: block;
            border: 1px solid #e1e7ed;
            border-radius: 10px;
            padding: 12px;
            width: 100%;
            height: 100%;
        `,
    },
    productDesc: {
        css: css`
            font-size: 16px;
            color: #353432;
        `,
    },
    contentWrap: {
        css: css`
            display: flex;
            flex-direction: row;
        `,
    },
    desc: {
        css: css`
            font-size: 14px;
            color: #353432;
        `,
    },
    title: {
        css: css`
            font-weight: 600;
            font-size: 14px;
            color: #353432;
        `,
    },
};

const styles = productDetailsKitSectionOptionsStyles;

const ProductDetailsKitSectionOptions = ({ configuration }: Props) => {
    if (
        !configuration ||
        !configuration.isKit ||
        !configuration.configSections ||
        configuration.configSections.length === 0
    ) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            {configuration.configSections.map(
                configSection =>
                    !!configSection.sectionOptions?.length && (
                        <StyledWrapper {...styles.configSectionWrapper} key={configSection.id}>
                            <Typography {...styles.configSectionLabel}>
                                {configSection.label || configSection.sectionName}:
                                </Typography>

                                <GridContainer {...styles.kitContainer}>
                                    {configSection.sectionOptions?.map(sectionOption => {
                                        const nameAndDescriptionArray = sectionOption.description.split("||");
                                        const productAssignName = nameAndDescriptionArray[0].trim();
                                        const productAssignDescription = nameAndDescriptionArray[1].trim();
                                        return (
                                            <GridItem {...styles.kitWrap} key={sectionOption.id}>
                                                <StyledWrapper {...styles.gridWrapper}>
                                                    <Typography {...styles.sectionOptionText}>
                                                        {productAssignName}
                                                    </Typography>
                                                    <Typography {...styles.productDesc}>
                                                        {productAssignDescription}
                                                    </Typography>
                                                    <StyledWrapper {...styles.contentWrap}>
                                                        <Typography {...styles.title}>Part# </Typography>
                                                        <Typography {...styles.desc}>{sectionOption.name}</Typography>
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.contentWrap}>
                                                        <Typography {...styles.title}>QTY: </Typography>
                                                        <Typography {...styles.desc}>
                                                            {sectionOption.quantity}
                                                        </Typography>
                                                    </StyledWrapper>
                                                    {/* <Typography {...styles.sectionOptionText}>
                                                part#{sectionOption.name}
                                            </Typography>
                                            <Typography {...styles.sectionOptionText}>
                                                QTY: 
                                            </Typography> */}
                                                </StyledWrapper>
                                            </GridItem>
                                        );
                                    })}
                                </GridContainer>
                                {/* <Typography {...styles.sectionOptionText} key={sectionOption.id}>
                                        {sectionOption.description}
                                    </Typography> */}
                            </StyledWrapper>
                        ),
                )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withParentProductId(connect(mapStateToProps)(ProductDetailsKitSectionOptions)),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
